// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallToAction_wrapper__luW_r","image":"CallToAction_image__Sl9r6"};